function popup() {

    /**
     * Add a special redirection handler that checks for GET params.
     */
    POP.Window.Redirect = function() {
        var params = $.url().param(),
            $form,
            hidden = [];

        if (!params || !params.url) {
            void 0;
            return false;
        }

        // generate hidden inputs for each param
        _.each(params, function(val, key) {
            if (key != 'url') {
                hidden.push('<input type="hidden" name="' + key + '" value="' + val + '" />');
            }
        });

        $form = $('<form>', {
            method: 'POST',
            action: params.url
        });

        $form.html(hidden.join('')).appendTo(document.body);
        $form.submit();
    }

    // trigger redirection
    POP.Window.Redirect();

}
